<div class="container my-4">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">LTE Top Up History</span>
        </div>
    </div>
    <div class="card card_content">
        <div class="row d-flex  align-items-center flex-wrap grid-margin mb-2">
            <div class="col-md-4">
                <!-- <button type="button" class="btn btn-secondary mr-2" (click)="clearFilter()">
          <i class="fa fa-refresh"></i> Refresh
        </button> -->
                <app-button (refreshClicked)="clearFilter()"></app-button>

                <!-- <button type="button" class="btn excel_btn text-nowrap mr-2" (click)="exportAsXLSX()">
          <i class="fa fa-file-excel"></i> Export
        </button> -->
            </div>
            <div class="col-md-4 padd-right-file" style="display: flex;">
                <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'searchText-mat-field'">
                    <mat-label>Search</mat-label>
                    <div class="search-input-container">
                        <input formControlName="searchQuery"
                            placeholder="Enter Customer Number / Application / transactionId" id="search"
                            matInput type="text" #searchInput (keydown.enter)="getTableData($event)">
                    </div>
                </mat-form-field>
                <button matSuffix mat-icon-button aria-label="Search" class="badge bg-light-blue image-button"
                    (click)="getTableData($event)">
                    <mat-icon style="color: white;"> search</mat-icon>
                </button>
            </div>


        </div>

        <div class="table-responsive d-none d-md-block">
            <mat-table #table [dataSource]="dataSource" matSort matSortDirection="asc">

                <ng-container matColumnDef="ApplicationRef">
                    <mat-header-cell *matHeaderCellDef>Application<br>Reference</mat-header-cell>
                    <mat-cell *matCellDef="let dataField" style="width: 4%;">
                        <p class="text-truncate txtalign" style=" color: blueviolet;font-weight: 900;">
                            {{dataField.ApplicationRef}}</p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="CustomerReference" style="width: 5%;">
                    <mat-header-cell *matHeaderCellDef 
                        style="width: 5%;">Customer<br>Reference</mat-header-cell>
                    <mat-cell *matCellDef="let dataField" style="width: 5%;">
                        <p class="text-truncate txtalign"> {{dataField.CustomerRef}}</p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="TopupPlan" style="width: 5%;">
                    <mat-header-cell *matHeaderCellDef style="width: 5%;">Topup
                        Plan</mat-header-cell>
                    <mat-cell *matCellDef="let dataField" style="width: 4%;">
                        <p class="text-truncate txtalign">{{dataField.productName}}GB</p>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="PurchasedDate" style="width: 3%;">
                    <mat-header-cell *matHeaderCellDef style="width: 3%;">Purchased
                        Date</mat-header-cell>
                    <mat-cell *matCellDef="let dataField" style="width: 3%;">
                        <p class="text-truncate txtalign"> {{dataField.purchaseDate | date:'dd-MMM-yyyy'}}</p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="ExpierDate" style="width: 3%;">
                    <mat-header-cell *matHeaderCellDef  style="width: 3%;">Expiry
                        Date</mat-header-cell>
                    <mat-cell *matCellDef="let dataField" style="width: 3%;">
                        <p class="text-truncate txtalign">
                            {{dataField.expieryDate | date:'dd-MMM-yyyy'}}</p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="TransactionId" style="width: 5%;">
                    <mat-header-cell *matHeaderCellDef  style="width: 5%;">Transaction
                        Id</mat-header-cell>
                    <mat-cell *matCellDef="let dataField" style="width: 3%;">
                        <p class="text-truncate txtalign">{{dataField.transactionId }}</p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="PaymentType" style="width: 2%;">
                    <mat-header-cell *matHeaderCellDef 
                        style="width: 2%;">PaymentType</mat-header-cell>
                    <mat-cell *matCellDef="let dataField" style="width: 2%;">
                        <p class="text-truncate txtalign">
                            {{dataField.paymentType }}</p>
                    </mat-cell>
                </ng-container>

                <!-- <ng-container matColumnDef="Status">
          <mat-header-cell *matHeaderCellDef mat-sort-header="Status">Status</mat-header-cell>
          <mat-cell *matCellDef="let dataField" style="width: 3%;">
            <p class="text-truncate txtalign" style="white-space: normal">{{dataField.status}}
            </p>
          </mat-cell>
        </ng-container> -->

                <ng-container matColumnDef="Price" style="width: 3%;">
                    <mat-header-cell *matHeaderCellDef 
                        style="width: 5%;">Price</mat-header-cell>
                    <mat-cell *matCellDef="let dataField" style="width: 3%;">
                        <p class="text-truncate txtalign"
                            style="text-align: center; color: blueviolet;font-weight: 900;">
                            R{{dataField.price.toFixed(2)}}
                        </p>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>

                <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple>
                </mat-row>
            </mat-table>
        </div>

        <div class="table_pagenation d-none d-md-block">
            <mat-paginator #paginator [length]="dataSource!==null && dataSource.filteredData.length" [pageIndex]="0"
                [pageSize]="10" [pageSizeOptions]="[10, 25, 50, 100]">
            </mat-paginator>
        </div>
    </div>
</div>